/**
 * @type {BookApiAdapter}
 */
export const googleBooksAdapter = {
    name: 'Google Books',

    async fetch(isbn) {
        try {
            const response = await fetch(`https://www.googleapis.com/books/v1/volumes?q=isbn:${isbn}&maxResults=1`);
            const data = await response.json();
            const book = data.items?.[0]?.volumeInfo;

            if (!book) {
                console.log(`BD ISBN ${isbn} non trouvée sur Google Books`)
                return null
            };

            let title = book.title;
            let series = book.subtitle ?? null;

            if (book.title && book.subtitle) {
                series = book.title;
                title = book.subtitle;
            }

            return {
                isbn: isbn,
                title: title,
                authors: book.authors?.join(', ') ?? null,
                publisher: book.publisher ?? null,
                series: series,
                coverUrl: book.imageLinks?.thumbnail?.replace('http:', 'https:') ?? null,
            };
        } catch (error) {
            console.error("Erreur réseau lors de l'appel à Google Books :", error);
            return null
        }
    }
};
